/**
 * Created by marka on 3/21/2017.
 */
import React, { Component } from 'react';

class PatientMatch extends Component {

    render() {
        const patient=this.props.patient;
        patient.matchKey = this.props.matchKey;
        let dateOfBirth = null;
        if (patient.dateOfBirth && patient.dateOfBirth.length === 10) {
        	dateOfBirth = patient.dateOfBirth.substring(5, 7) + "/" + patient.dateOfBirth.substring(8, 10) + "/" + patient.dateOfBirth.substring(0, 4);
        }
        let contextualClass = "";
        if (this.props.matchKey === this.props.selectedPatientMatchKey) {
            contextualClass = "active";
        }
        return (
            <tr style={{"cursor":"pointer"}} className={contextualClass} onClick={() => {this.props.select(patient)}}>
                <td>
                    <span hidden={patient.gender!=='F'}><i className="fa fa-female"></i> </span>
                    <span hidden={patient.gender!=='M'}><i className="fa fa-male"></i> </span>
                </td>
                <td>
                    {patient.nameFirst} {patient.nameMiddle} {patient.nameLast}
                </td>
                <td>
                    {dateOfBirth}
                </td>
                <td>
                    {this.props.patient.source === "ELLKAY" ? "EMR" : "GDX"}
                </td>
            </tr>
        );
    }

}
export default PatientMatch;
